module.exports = __webpack_public_path__ + "img/gongzi_6.d87aed99.png";